import { ResumeStateType } from './resume.state';

const initialResumeState: ResumeStateType = {
  email: 'kroy760@gmail.com',
  resumes: {},
} as ResumeStateType;

export { initialResumeState };
